import React from "react";
import { Box, Typography } from "@mui/material";
import CustomModal from "../CustomModal/CustomModal";
import CustomTextArea from "../CustomTextArea/CustomTextArea";

import Button from "../CustomButtons/Button";
import modalStyle from "../../assets/jss/material-dashboard-react/components/notificationModalStyle";
import resources from "../../core/Localization/Localization.js";
import CustomInput from "../CustomInput/CustomInput";


export default function NotificationModal(props) {
    const { open, handleClose, title, text, buttonLabel, onConfirmCallback, error } = props;

    const [messageText, setMessageText] = React.useState("");
    const [titleText, setTitleText] = React.useState("");

    const resetValues = () => {
        setMessageText("");
        setTitleText("");
    };

    return (
        <CustomModal open={open} onClose={handleClose}>
            <Box sx={modalStyle.titleContainer}>
                <Typography className={modalStyle.titleText}>{title}</Typography>
            </Box>
            <Box sx={modalStyle.bodyContainer}>
                <CustomInput
                    labelText={resources.userNotifications.title}
                    id="title"
                    inputProps={{
                        value: titleText,
                        onChange: (e) => setTitleText(e.target.value),
                    }}
                    formControlProps={{
                        fullWidth: true,
                    }}
                ></CustomInput>
                <Typography sx={modalStyle.bodyText}>{text}</Typography>
                <CustomTextArea
                    labelText={resources.userNotifications.message}
                    // error={!!errors.description}
                    id="message"
                    inputProps={{
                        value: messageText,
                        onChange: (e) => setMessageText(e.target.value),
                    }}
                    formControlProps={{
                        fullWidth: true,
                    }}
                />
                {error ? <p style={modalStyle.error}>{error}</p> : null}
            </Box>
            <Box sx={modalStyle.footerContainer}>
                <Button
                    type={"button"}
                    size={"sm"}
                    sx={modalStyle.button}
                    onClick={() => {
                        resetValues();
                        handleClose();
                    }}
                >
                    {resources.cancel}
                </Button>
                <Button
                    type={"button"}
                    color={"info"}
                    size={"sm"}
                    onClick={() => {
                        if (titleText && messageText) resetValues();
                        onConfirmCallback(titleText, messageText);
                    }}
                >
                    {buttonLabel}
                </Button>
            </Box>
        </CustomModal>
    );
}
